import type { ICustomStrikeZone } from 'interfaces/session/ICustomStrikeZone';
import type { IStrikeZoneDefinition } from 'interfaces/session/IStrikeZoneDefinition';
import type { IApiLeague } from 'interfaces/team/IApiScheduleResponse';
import { mapCalculationsToLocations } from './strikeZonePlanes';

/**
 * Builds the `strikeZone` node of a sessionMetadataUpdated payload.
 *
 * The main node always carries the league's own values — dimensions and plane locations alike.
 * `customDefinition` carries what the operator edited. When the operator edited nothing, both
 * nodes hold the same locations, because the plane editor is seeded from the league.
 */
export const buildSessionStrikeZone = (league: IApiLeague, customStrikeZone: ICustomStrikeZone | null): IStrikeZoneDefinition => {
  const leagueLocations = mapCalculationsToLocations(league.strikeZoneCalculationInformations);

  return {
    name: '',
    activeStrikeZone: league.activeStrikeZone,
    staticStrikeZoneBottom: league.strikeZones?.staticStrikeZone?.strikeZoneBottom,
    staticStrikeZoneTop: league.strikeZones?.staticStrikeZone?.strikeZoneTop,
    staticStrikeZoneWidth: league.strikeZones?.staticStrikeZone?.strikeZoneWidth,
    heightStrikeZoneBottomPercentage: league.strikeZones?.heightBasedStrikeZone?.strikeZoneBottomPercentage,
    heightStrikeZoneTopPercentage: league.strikeZones?.heightBasedStrikeZone?.strikeZoneTopPercentage,
    heightStrikeZoneWidth: league.strikeZones?.heightBasedStrikeZone?.strikeZoneWidth,
    topBottomStrikeZoneWidth: league.strikeZones?.topAndBottomStrikeZone?.strikeZoneWidth,
    ballDiameter: league.ballDiameter ?? null,
    locations: leagueLocations,
    customDefinition: customStrikeZone ? { ...customStrikeZone.definition, locations: customStrikeZone.locations ?? leagueLocations } : null,
  };
};
